import screenSize from "../../../styles/mediaQueries";
import GlobalTheme from "../../../styles/global.theme";
import styled, { css } from "styled-components";

export const ButtonWrapper = styled.div`
    display: block;

    ${screenSize.minDesktop`
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `}
`;

export const ButtonPurple = styled.button`
    width: ${(props) => props.width || "100%"};
    background-color: ${GlobalTheme.palette.purple.primary.main};
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    color: ${GlobalTheme.palette.white.primary.main};
    padding: 14px 20px 12px 20px;
    font-size: 16px;
    &:hover {
        background-color: ${GlobalTheme.palette.purple.primary.hover};
    }
    &:active {
        background-color: ${GlobalTheme.palette.purple.primary.hover};
    }
    &:disabled {
        background-color: ${GlobalTheme.palette.grey.primary.main};
        cursor: not-allowed;
    }
`;

export const ButtonPurpleNext = styled.button`
    width: 140px;
    background-color: ${GlobalTheme.palette.purple.primary.main};
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    color: ${GlobalTheme.palette.white.primary.main};
    padding: 14px 20px 12px 20px;
    font-size: 16px;
    &:hover {
        background-color: ${GlobalTheme.palette.purple.primary.hover};
    }
    &:active {
        background-color: ${GlobalTheme.palette.purple.primary.hover};
    }
    &:disabled {
        background-color: ${GlobalTheme.palette.grey.primary.main};
        cursor: not-allowed;
    }
    @media (max-width: 600px) {
        width: 100%;
    }
`;

export const ButtontWhite = styled.button`
    width: ${(props) => props.width || "100%"};
    background-color: ${GlobalTheme.palette.white.primary.main};
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    color: ${GlobalTheme.palette.purple.primary.main};
    padding: 14px 20px 12px 20px;
    font-size: 16px;
    gap: 8px;
`;

export const TextButton = styled.button`
    color: ${(props) =>
        props.color || `${GlobalTheme.palette.purple.primary.main}`};
    font-size: 16px;
    cursor: pointer;
`;

export const SubmitButton = styled("button", {
    shouldForwardProp: (prop) => prop !== "fullWidth",
})(({ fullWidth }) => ({
    backgroundColor: `${GlobalTheme.palette.purple.primary.main}`,
    color: `${GlobalTheme.palette.white.primary.main}`,
    fontSize: "16px",
    padding: "15px 20px",
    border: "none",
    borderRadius: "4px",
    width: "100%",
    "@media (max-width: 320px)": {
        padding: "12px 15px",
        fontSize: "16px",
    },

    "@media (max-width: 780px)": {
        padding: "12px 15px",
        fontSize: "16px",
    },
}));

// delete
export const NextButton = styled("button")(({ fullWidth }) => ({
    backgroundColor: `${GlobalTheme.palette.purple.primary.main}`,
    color: `${GlobalTheme.palette.white.primary.main}`,
    fontSize: `${GlobalTheme.typography.p.fontSize}`,
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginLeft: "auto",
    marginTop: "40px",
    width: fullWidth ? "100%" : "auto",
}));

export const ButtonBlue = styled("button")(({ fullWidth }) => ({
    backgroundColor: `${GlobalTheme.palette.purple.primary.main}`,
    color: `${GlobalTheme.palette.white.primary.main}`,
    fontSize: "16px",
    padding: "15px 20px",
    border: "none",
    borderRadius: "4px",
    width: fullWidth ? "100%" : "auto",
}));

export const NextBlueButton = styled("button")(({ fullWidth }) => ({
    backgroundColor: `${GlobalTheme.palette.purple.primary.main}`,
    color: `${GlobalTheme.palette.white.primary.main}`,
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    cursor: "pointer",
    width: "10%",
    marginLeft: "auto",
    marginRight: "50px",
    boxShadow: "none",
    outline: "none",
    overflowX: "hidden",
    "@media (max-width: 480px)": {
        padding: "10px",
        width: "100%",
        marginLeft: "50px",
    },
    "@media (max-width: 375px)": {
        padding: "10px",
        width: "100%",
        marginLeft: "50px",
    },
    "@media (max-width: 320px)": {
        padding: "10px",
        width: "90%",
        marginLeft: "50px",
    },
}));

export const ButtonBluePayroll = styled("button")(() => ({
    backgroundColor: `${GlobalTheme.palette.purple.primary.main}`,
    color: `${GlobalTheme.palette.white.primary.main}`,
    padding: "10px 20px",
    border: "none",
    borderRadius: "4px",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    cursor: "pointer",
    width: "10%",
    marginLeft: "auto",
    marginRight: "50px",
    "@media (max-width: 375px)": {
        padding: "10px",
        width: "80%",
        marginLeft: "auto",
        marginRight: "50px",
    },
    "@media (max-width: 320px)": {
        padding: "10px",
        width: "80%",
        marginLeft: "auto",
        marginRight: "50px",
    },
}));

export const ButtonPurpleTextLink = styled.a`
    text-decoration: none;
    font-family: ${GlobalTheme.typography.fontFamily};
    cursor: pointer;
    p {
        color: ${GlobalTheme.palette.purple.primary.main};
        margin: 0;
    }
    p:hover {
        color: ${GlobalTheme.palette.purple.primary.hover};
    }
    ${(props) =>
        props.disabled &&
        css`
            cursor: default;
            p {
                color: ${GlobalTheme.palette.grey.primary.main};
            }
            p:hover {
                color: ${GlobalTheme.palette.grey.primary.main};
            }
        `}
`;

export const ButtonWhiteTextLink = styled.a`
    text-decoration: none;
    font-family: Calibre, "Helvetica Neue", Helvetica, sans-serif;
    cursor: pointer;
    p {
        color: ${GlobalTheme.palette.white.primary.main};
        margin: 0;
    }
    p:hover {
        color: ${GlobalTheme.palette.white.primary.main};
    }
`;

export const UploadImage = styled.button`
    padding: 30px;
    background-color: ${GlobalTheme.palette.lightGrey.primary.main};
    color: ${GlobalTheme.palette.grey.primary.darker};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    & .MuiTypography-root {
        color: ${GlobalTheme.palette.black.primary.main};
        font-size: 18px;
    }
`;

export const CopyButton = styled.button`
    background-color: ${GlobalTheme.palette.purple.primary.main} !important;
    margin-right: 10px;
    border-left: 0;
    border-radius: 0 5px 5px 5px;
    color: ${GlobalTheme.palette.white.primary.main} !important;
    padding: 10px;
    font-size: 20px;
    font-weight: ${GlobalTheme.typography.fontWeightBold};
    height: 48px;
    width: 60px;
    margin-top: 10px;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: 31%;
    cursor: pointer;
    transform: translateY(-50%);
    &:active {
        transfrom: scale(4.4);
        box-shadow: inset 0 6px 6px rgba(255, 255, 255, 0.3);
    }
    @media (max-width: 320px) {
        padding: 5px 10px;
        font-size: 14px;
        width: 20%;
        height: 60px;
    }
    ${screenSize.minMobile`
    padding: 8px 14px;
    font-size: 14px;
    height: 55px;
    width: 20%;
   `};
    ${screenSize.minLargeMobile`
    padding: 8px 14px;
    font-size: 20px;
    font-weight: ${GlobalTheme.typography.fontWeightBold};
    height: 55px;
    width: 10%;
   `};
    ${screenSize.minDesktop`
    padding: 8px 14px;
    font-size: 20px;
    font-weight: ${GlobalTheme.typography.fontWeightBold};
    height: 55px;
    width: 10%;
   `};
`;
